import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';

import {
  PAGE_LOADING,
  PAGE_LOADED,
  SET_HIDE_FOOTER,
  SET_HIDE_HEADER,
} from './actions';

const INITIAL_STATE = Immutable({
  loading: false,
  hideFooter: false,
  hideHeader: false,
});

const actionMap = {
  // Reset on every page load so a page that hides the footer/header (see
  // use-hide-footer.js / use-hide-header.js) can't leak that into whichever
  // page loads next.
  [PAGE_LOADING]: (state) =>
    Immutable({
      ...state,
      loading: true,
      hideFooter: false,
      hideHeader: false,
    }),
  [PAGE_LOADED]: (state) => Immutable({ ...state, loading: false }),
  [SET_HIDE_FOOTER]: (state, { payload }) =>
    Immutable({ ...state, hideFooter: !!payload }),
  [SET_HIDE_HEADER]: (state, { payload }) =>
    Immutable({ ...state, hideHeader: !!payload }),
};

export default handleActions(actionMap, INITIAL_STATE);
